export const changeTable = (table) => ({
  type: "CHANGE_SERVICING_TABLE",
  payload: table,
});
